import React from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

const OPTIONS = [
  {
    title: "Beneficiarios Legales",
    description: "Consulte designaciones actuales e historico de beneficiarios.",
    route: "ConsultarDesignacion",
  },
];

export default function MenuConsultarDesignacion() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <Paper
        elevation={2}
        sx={{
          p: 2.5,
          borderRadius: 3,
          border: "1px solid #dce7f7",
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <FactCheckOutlinedIcon sx={{ color: "#19498c" }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: "#19498c" }}>
            Consulta de Beneficiarios Legales
          </Typography>
        </Stack>

        <Grid container spacing={2}>
          {OPTIONS.map((option) => (
            <Grid key={option.route} item xs={12} md={6}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2.5,
                  borderColor: "#dce7f7",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box>
                  <Typography sx={{ fontWeight: 700, color: "#1a2f4d" }}>
                    {option.title}
                  </Typography>
                  <Typography sx={{ color: "#5a6a80", fontSize: 14, mt: 0.6 }}>
                    {option.description}
                  </Typography>
                </Box>

                <Button
                  variant="contained"
                  onClick={() => navigate(`/Enrolamiento/${option.route}`)}
                  sx={{
                    alignSelf: "flex-start",
                    textTransform: "none",
                    fontWeight: 700,
                    backgroundColor: "#19498c",
                  }}
                >
                  Abrir
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Box>
  );
}
